<div class="issue-mgmt">
  <div class="filter">
    <button
      type="button"
      class="btn btn-success btn-xs add-issue-btn"
      [disabled]="loading()"
      (click)="addIssue()">
      Add New Issue
    </button>

    @if (!loading() && data().length) {
      <div class="issue-search-wrap">
        <i class="fa fa-search issue-search-icon" aria-hidden="true"></i>
        <input
          #searchBox
          type="search"
          class="issue-search-input"
          placeholder="Search issues..."
          aria-label="Search issues"
          (input)="onSearchInput($event)" />
        @if (searchTerm()) {
          <button
            type="button"
            class="issue-search-clear"
            title="Clear search"
            aria-label="Clear search"
            (click)="clearSearch(searchBox)">
            <i class="fa fa-times-circle" aria-hidden="true"></i>
          </button>
        }
      </div>
    }
  </div>

  @if (loading()) {
    <div class="data-loader-container flex-center">
      <i class="fa fa-spinner fa-spin data-loader" aria-hidden="true"></i>
      <span>Loading...</span>
    </div>
  }

  @if (!loading() && tableRows().length) {
    <div class="table-wrapper table-scroll">
      <table class="issue-mgmt-table">
        <thead>
          <tr>
            <th [attr.aria-sort]="ariaSort('issue_id')">
              <button type="button" class="sort-btn" (click)="sortBy('issue_id')">
                Issue Id
                <i class="fa" [class.fa-sort]="sortField() !== 'issue_id'" [class.fa-sort-asc]="sortField() === 'issue_id' && sortDirection() === 'asc'" [class.fa-sort-desc]="sortField() === 'issue_id' && sortDirection() === 'desc'" aria-hidden="true"></i>
              </button>
            </th>
            <th [attr.aria-sort]="ariaSort('issue_short_desc')">
              <button type="button" class="sort-btn" (click)="sortBy('issue_short_desc')">
                Issue Short Description
                <i class="fa" [class.fa-sort]="sortField() !== 'issue_short_desc'" [class.fa-sort-asc]="sortField() === 'issue_short_desc' && sortDirection() === 'asc'" [class.fa-sort-desc]="sortField() === 'issue_short_desc' && sortDirection() === 'desc'" aria-hidden="true"></i>
              </button>
            </th>
            <th [attr.aria-sort]="ariaSort('issue_desc')">
              <button type="button" class="sort-btn" (click)="sortBy('issue_desc')">
                Issue Description
                <i class="fa" [class.fa-sort]="sortField() !== 'issue_desc'" [class.fa-sort-asc]="sortField() === 'issue_desc' && sortDirection() === 'asc'" [class.fa-sort-desc]="sortField() === 'issue_desc' && sortDirection() === 'desc'" aria-hidden="true"></i>
              </button>
            </th>
            <th [attr.aria-sort]="ariaSort('qar_desc')">
              <button type="button" class="sort-btn" (click)="sortBy('qar_desc')">
                Standard Description
                <i class="fa" [class.fa-sort]="sortField() !== 'qar_desc'" [class.fa-sort-asc]="sortField() === 'qar_desc' && sortDirection() === 'asc'" [class.fa-sort-desc]="sortField() === 'qar_desc' && sortDirection() === 'desc'" aria-hidden="true"></i>
              </button>
            </th>
            <th class="text-center" [attr.aria-sort]="ariaSort('tax_year')">
              <button type="button" class="sort-btn sort-btn-center" (click)="sortBy('tax_year')">
                Tax Year
                <i class="fa" [class.fa-sort]="sortField() !== 'tax_year'" [class.fa-sort-asc]="sortField() === 'tax_year' && sortDirection() === 'asc'" [class.fa-sort-desc]="sortField() === 'tax_year' && sortDirection() === 'desc'" aria-hidden="true"></i>
              </button>
            </th>
            <th class="text-center" [attr.aria-sort]="ariaSort('scenario')">
              <button type="button" class="sort-btn sort-btn-center" (click)="sortBy('scenario')">
                Scenario
                <i class="fa" [class.fa-sort]="sortField() !== 'scenario'" [class.fa-sort-asc]="sortField() === 'scenario' && sortDirection() === 'asc'" [class.fa-sort-desc]="sortField() === 'scenario' && sortDirection() === 'desc'" aria-hidden="true"></i>
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (row of tableRows(); track row.issue_id) {
            <tr>
              <td>
                <span class="edit-issue">
                  {{ row.issue_id }}
                  <button
                    type="button"
                    class="edit"
                    title="Edit issue"
                    aria-label="Edit issue"
                    (click)="editIssue(row)">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                  </button>
                </span>
              </td>
              <td>{{ row.issue_short_desc }}</td>
              <td>{{ row.issue_desc }}</td>
              <td>{{ row.qar_desc }}</td>
              <td class="text-center">{{ row.tax_year }}</td>
              <td class="text-center">{{ row.scenario }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (!loading() && data().length && !tableRows().length) {
    <div class="empty-state">
      <i class="fa fa-search" aria-hidden="true"></i>
      <span>No issues match your search.</span>
    </div>
  }
</div>
